import React, { useState } from 'react'
import Countries from '../Json/Countries.json';
import { BsArrowRightShort } from 'react-icons/bs';
import { HouseIcon } from '../../Assets/AllSvg';
import { HiChevronUpDown } from 'react-icons/hi2';

const PublicDetails = ({setStep, setMainStep, publicDetail, setPublicDetail, isUpdate, setData }) => {
    const [validStatement, setValidStatement] = useState('')
    const [validShortened, setValidShortened] = useState('')
    const [validNumber, setValidNumber] = useState('')

    const handleContinue = () => {
        if (!validation()) {
            if(isUpdate){
                setMainStep('step5');
                setStep('Summary');
                setData('default')
            } else {
                setMainStep('step2')
                setStep('bank-detail')
            }
        }
    }

    const validation = () => {
        let valid = false;
        if (publicDetail.statement_descriptor === "") {
            setValidStatement("Please provide a statement descriptor.");
            valid = true;
        }
        if (publicDetail.shortened_descriptor === "") {
            setValidShortened("Please provide a shortened descriptor.");
            valid = true;
        }
        if(publicDetail.customer_suport_phone === ''){
            setValidNumber("Please provide a phone number.");
            valid = true;
        }
        return valid;
    }

    return (
        <div>
            <div>
                <h3 className='text-[#30313d] sm:text-[32px] text-[24px] font-semibold leading-[42px]'>Add public details for customers</h3>
                <p className='text-[#414552] mt-2'>This information may be visible in payment statements, invoices, and receipts.</p>
                <div className="sm:mt-[40px] mt-[20px]">
                    <div className='group relative'>
                        <label htmlFor="Statement-descriptor" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Statement descriptor</label>
                        <div className="relative mt-1 w-full">
                            <input
                                value={publicDetail.statement_descriptor}
                                onChange={(e) => setPublicDetail({ ...publicDetail, statement_descriptor: e.target.value })}
                                type='text' id="Statement-descriptor" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Your business name' />
                            <p className="text-red-600">{publicDetail.statement_descriptor === "" ? validStatement : ""}</p>
                        </div>
                        <div className='lg:hidden lg:group-hover:block block show-text opacity-0 group-hover:opacity-100'>
                            <div className='p-[8px] rounded-[6px] bg-white shadow-[0_2px_5px_0_rgba(65,69,82,0.08),0_1px_1px_0_rgba(0,0,0,0.12)]'>
                                <div className='flex gap-2 items-center pb-[8px] mb-[8px] shadow-[inset_0_-1px_rgb(235,238,241)]'>
                                    <HouseIcon className="h-[12px] w-[12px] fill-[#ebeef1]" />
                                    <div className='w-[52px] h-[8px] bg-[#f6f8fa] shadow-[inset_0_-1px_rgb(235,238,241)]'></div>
                                </div>
                                <div className='flex justify-between pb-[6px]'>
                                    <div className='w-[56px] h-[8px] bg-[#f6f8fa] shadow-[inset_0_-1px_rgb(235,238,241)]'></div>
                                    <span className='text-[#c0c8d2] text-xs'>$20.00</span>
                                </div>
                                <div className='flex justify-between'>
                                    <span className='text-xs text-[#625afa]'>{publicDetail.statement_descriptor !== '' ? publicDetail.statement_descriptor.toUpperCase() : 'YOUR BUSINESS NAME'}</span>
                                    <span className='text-[#414552] text-xs'>$340.00</span>
                                </div>
                                <div className='flex justify-between items-center pt-[6px]'>
                                    <div className='flex gap-2'>
                                        <div className='w-[56px] h-[8px] bg-[#f6f8fa] shadow-[inset_0_-1px_rgb(235,238,241)]'></div>
                                        <div className='w-[56px] h-[8px] bg-[#f6f8fa] shadow-[inset_0_-1px_rgb(235,238,241)]'></div>
                                    </div>
                                    <span className='text-[#c0c8d2] text-xs'>$63.00</span>
                                </div>
                            </div>
                            <p className='text-sm mt-3 text-[#414552]'>Your statement descriptor shows up on your customers’ bank or credit card statements. It should be 5-22 characters.</p>
                        </div>
                    </div>
                    <div className='sm:mt-[30px] mt-[20px] group relative'>
                        <label htmlFor="Shortened-descriptor" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Shortened descriptor</label>
                        <div className="relative mt-1 w-full">
                            <input
                                value={publicDetail.shortened_descriptor}
                                onChange={(e) => setPublicDetail({ ...publicDetail, shortened_descriptor: e.target.value })}
                                type='text' id="Shortened-descriptor" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Business' />
                            <p className="text-red-600">{publicDetail.shortened_descriptor === "" ? validShortened : ""}</p>
                        </div>
                        <div className='lg:hidden lg:group-hover:block block show-text opacity-0 group-hover:opacity-100'>
                            <div className='p-[8px] rounded-[6px] bg-white shadow-[0_2px_5px_0_rgba(65,69,82,0.08),0_1px_1px_0_rgba(0,0,0,0.12)]'>
                                <div className='flex gap-2 items-center pb-[8px] mb-[8px] shadow-[inset_0_-1px_rgb(235,238,241)]'>
                                    <HouseIcon className="h-[12px] w-[12px] fill-[#ebeef1]" />
                                    <div className='w-[52px] h-[8px] bg-[#f6f8fa] shadow-[inset_0_-1px_rgb(235,238,241)]'></div>
                                </div>
                                <div className='flex justify-between pb-[6px]'>
                                    <div className='w-[56px] h-[8px] bg-[#f6f8fa] shadow-[inset_0_-1px_rgb(235,238,241)]'></div>
                                    <span className='text-[#c0c8d2] text-xs'>$20.00</span>
                                </div>
                                <div className='flex justify-between'>
                                    <span className='text-xs text-[#625afa]'>{publicDetail.shortened_descriptor !== '' ? publicDetail.shortened_descriptor.toUpperCase() : 'BUSINESS'}* TSHIRT</span>
                                    <span className='text-[#414552] text-xs'>$340.00</span>
                                </div>
                                <div className='flex justify-between items-center pt-[6px]'>
                                    <div className='flex gap-2'>
                                        <div className='w-[56px] h-[8px] bg-[#f6f8fa] shadow-[inset_0_-1px_rgb(235,238,241)]'></div>
                                        <div className='w-[56px] h-[8px] bg-[#f6f8fa] shadow-[inset_0_-1px_rgb(235,238,241)]'></div>
                                    </div>
                                    <span className='text-[#c0c8d2] text-xs'>$63.00</span>
                                </div>
                            </div>
                            <p className='text-sm mt-3 text-[#414552]'>You may provide more specific details about a charge with dynamic suffixes. When a suffix is used, it is combined with the shortened descriptor on card statements.</p>
                        </div>
                    </div>
                    <div className='sm:mt-[30px] mt-[20px] group relative'>
                        <label className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Customer support phone number</label>
                        <div className="rounded-[6px] mt-1 w-full flex items-center relative">
                            <div className='text-sm pl-2 text-[#414552] absolute top-[50%] translate-y-[-50%] left-1'>+1</div>
                            <input
                                value={publicDetail.customer_suport_phone}
                                onChange={(e) => setPublicDetail({...publicDetail, customer_suport_phone: e.target.value})}
                                type='number' placeholder='(201) 555-0123' id="Company-identification" className=" pr-3 pl-9 text-[#404452] rounded-[6px] input_focus_shadow w-full bg-white font-normal focus:outline-none h-[36px] py-1 text-[14px]" />
                        </div>
                        <p className="text-red-600">{publicDetail.customer_suport_phone === "" ? validNumber : ""}</p>
                    </div>
                    <div className='sm:mt-[30px] mt-[20px] group relative'>
                        <label htmlFor="Home-address" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Customer support address</label>
                        <div>
                            <div className="relative w-full mt-1">
                                <select disabled id="Home-address" value={publicDetail.customer_suport_country} className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-medium rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px] appearance-none">
                                    {Countries.slice(1).map((val, i) => {
                                        return (
                                            <option key={i} value={val.country}>{val.country}</option>
                                        )
                                    })}
                                </select>
                                <HiChevronUpDown className="absolute top-[50%] translate-y-[-50%] text-[#404552] right-0 flex items-center pr-1 text-[25px]" />
                            </div>
                            <div className='mt-5'>
                                <input
                                    value={publicDetail.customer_suport_address1}
                                    onChange={(e) => setPublicDetail({...publicDetail, customer_suport_address1: e.target.value})}
                                    type='text' className="input_focus_shadow text-[#404452 px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Address-line1' />
                                <input
                                    value={publicDetail.customer_suport_address2}
                                    onChange={(e) => setPublicDetail({...publicDetail, customer_suport_address2: e.target.value})}
                                    type='text' className="input_focus_shadow text-[#404452] mt-2 px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Address-line2' />
                                <input
                                    value={publicDetail.customer_suport_city}
                                    onChange={(e) => setPublicDetail({...publicDetail, customer_suport_city: e.target.value})}
                                    type='text' className="input_focus_shadow text-[#404452] mt-2 px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='City' />
                                <input
                                    value={publicDetail.customer_suport_zip}
                                    onChange={(e) => setPublicDetail({...publicDetail, customer_suport_zip: e.target.value})}
                                    type='text' className="input_focus_shadow text-[#404452] mt-2 px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='Zip' />
                                <div className="relative w-full mt-2">
                                    <select id="country" value={publicDetail.customer_suport_state} onChange={(e) => setPublicDetail({...publicDetail, customer_suport_state: e.target.value})} className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-medium rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px] appearance-none">
                                        {Countries.map((val) =>
                                            publicDetail.customer_suport_country === val.country &&
                                            val.states.map((state, i) => <option key={i} value={state} > {state}</option>)
                                        )}
                                    </select>
                                    <HiChevronUpDown className="absolute top-[50%] translate-y-[-50%] text-[#404552] right-0 flex items-center pr-1 text-[25px]" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='mt-6 pb-5'>
                        <button onClick={handleContinue} className='rounded-md flex items-center gap-1 font-semibold w-full h-[36px] px-4 py-2 justify-center text-white bg-[#625afa]'>Continue<BsArrowRightShort className='text-[25px]' /></button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PublicDetails